import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import axios from 'axios';
import config from '../config';
import Header from '../components/Header';
import CardioHistory from '../components/CardioHistory';
import CovidHistory from '../components/CovidHistory';
import * as action from '../actions'
import '../styles/testhistory.css';

axios.defaults.withCredentials = true;

const TestHistory = () => {
    const dispatch = useDispatch();
    const [user] = useState(useSelector((state) => state.user));
    const [currentTab, setCurrentTab] = useState("");
    const [isLoading, setLoading] = useState(true);
    const [privilege, setPrivilege] = useState({
        covid_access: user.covid_access,
        covid_demo_access: user.covid_demo_access,
        cardio_access: user.cardio_access,
        cardio_poc_access: user.cardio_poc_access,
    });

    const getUserAccessData = () => {
        axios.get(config.backend_url+'/useroperations/getPrivileges')
        .then( (response) => {
            if(response.status === 200){
                // storing user details into redux for using it into the other pages of application
                let updateUser = {
                    uid: user.uid,
                    firstName: user.firstName,
                    lastName: user.lastName,
                    last_visit: user.last_visit,
                    picture: user.picture,
                    loggedIn_time: user.loggedIn_time,
                    verified: user.verified,
                    ...response.data.privilege
                };
                
                dispatch(action.updateUser({ ...user, ...updateUser}));
                setPrivilege(response.data.privilege);
                if(response.data.privilege.covid_access) {
                    setCurrentTab("covid")
                } else if(response.data.privilege.cardio_access) {
                    setCurrentTab("cardio")
                } else {
                    setCurrentTab("")
                }
                setLoading(false);
            }
        })
    }

    useEffect(() => {
        document.title = "Test History";
        getUserAccessData();
    }, [])

    return (
        <div className='container'>
            {isLoading ? <div id="homepage-loading" data-testid="homepage-loading"></div> : <></>}
            <div className='main test-history mt-3'>
                <Header/>
                <p className="mt-3 heading">History</p>
                {currentTab ? <>
                    <ul className="nav nav-tabs border-0 main-tabs">
                    {privilege.covid_access && <li className="nav-item cursor-pointer covid-tab" onClick={() => setCurrentTab("covid")} data-testid="covid-tab">
                        <p className={currentTab == "covid" ? "nav-link active bg-primary text-white border-0" : "nav-link border-0"} aria-current="page">COVID-19</p>
                    </li>}
                    {privilege.cardio_access && <li className="nav-item cursor-pointer cardio-tab" onClick={() => setCurrentTab("cardio")} data-testid="cardio-tab">
                        <p className={currentTab == "cardio" ? "nav-link active bg-primary text-white border-0" : "nav-link border-0"} >Cardio</p>
                    </li>}
                    </ul>
                    {
                        currentTab == "covid" ? <CovidHistory /> : <CardioHistory />
                    }
                </> : <><p className="mt-5 heading">No access to test historys</p></>}
            </div>
        </div>
    )
}

export default TestHistory;